<template>
    <div class="connectivity">
        <video class="w-full h-full inset-0 absolute z-0" ref="video" @ended="showButtons()">
            <source v-if="de" src="/showroom/media/konnektivitaet_de.mp4" type="video/mp4">
            <source v-else src="/showroom/media/konnektivitaet_en.mp4" type="video/mp4">
        </video>
        <!-- after last frame -->
        <div class="z-10 relative w-full h-full">
            <div class="flex justify-center items-center w-full h-full" :class="{ 'aniConnectivity_buttonsIn': addAnimation }" v-if="addAnimation">
              <button class="btn btn-secondary relative z-10 opacity-0 mr-8 z-20" @click="restartVideo()">{{ $t('connectivit.restart') }}</button>
              <button class="btn btn-secondary relative z-10 opacity-0 z-20" @click="goBack()">{{ $t('overview-back') }}</button>
              <div class="fade absolute w-full h-full inset-0 bg-black bg-opacity-75 z-10"></div>
            </div>
            <button @click="playVideo()" class="btn btn-green btn-small btn-error">{{ $t('connectivit.help')}}<font-awesome-icon :icon="['fas', 'play']" /></button>
            <button @click="pauseVideo(), togglePause()" v-if="!pause" class="btn btn-green btn-small btn-pause">{{ $t('connectivit.pause')}} <font-awesome-icon :icon="['fas', 'pause']" /></button>
            <button @click="playVideo(), togglePause()" v-if="pause" class="btn btn-green btn-small btn-pause">{{ $t('connectivit.play')}} <font-awesome-icon :icon="['fas', 'play']" /></button>
            <button @click="goBack()" class="btn btn-green btn-small btn-home">{{ $t('overview-back') }}</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Connectivity',
  data() {
    return {
      addAnimation: false,
      pause: false,
      de: false,
    }
  },
  methods: {
    restartVideo() {
      this.addAnimation = false;
      this.$refs.video.currentTime = 0;
      this.$refs.video.play();
      // setTimeout(() => this.showButtons(), 74000);
    },
    pauseVideo() {
      this.$refs.video.pause();
    },
    playVideo() {
      this.$refs.video.play();
    },
    togglePause() {
      this.pause = !this.pause;
    },
    goBack() {
      this.$router.push({ path: '/', query: { skip: 1, lang: this.$i18n.locale }})
    },
    showButtons() {
      this.addAnimation = true;
    }
  },
  mounted() {
    // wait for router animation to end
    this.$i18n.locale = this.$route.query.lang;
    if(this.$i18n.locale == 'de' || this.$i18n.locale == undefined) {
      this.$data.de = true;
    }
    setTimeout(() => {
      this.$refs.video.play();
      // setTimeout(() => this.showButtons(), 74000);
    }, 1000)
  }
}
</script>

<style lang="scss">
.aniConnectivity_buttonsIn .btn {
  animation: reveal100 .3s ease .7s forwards;
}
.aniConnectivity_buttonsIn .fade {
  animation: fadeIn75 .5s ease 0s forwards;
}
</style>
